<div
  *ngIf="!isAllowedGlobalStyling"
  class="card h-100 position-relative cursor-pointer pointer-events-none webkit-tap-highlight-color-transparent́ shadow-none"
  (click)="
    goToLink(
      multiIconQuickLinksData.url,
      multiIconQuickLinksData.role
    )
  "
>
  <button
    [disabled]="disableButton"
    class="title position-absolute-fill is-space-between"
    [ngStyle]="contentStyle"
  >
    <mat-icon class="mr-2 left-icon" *ngIf="leftIcon" svgIcon="{{ leftIcon }}"></mat-icon>
    <div class="mr-auto" [ngStyle]="textContentStyle" [innerHTML]="headerSubheaderTemplate | safeHtml"></div>
    <mat-icon class="position-relative" *ngIf="rightIcon" svgIcon="{{ rightIcon }}"></mat-icon>
  </button>
</div>

<!-- If isAllowedGlobalStyling is true, the Multiquick link acts as a button -->

<div #buttonContent class="h-100 w-100" *ngIf="isAllowedGlobalStyling">
  <finx-button
    [labeltext]="headerSubheaderTemplate ?? ''"
    class="pointer-events-none d-flex"
    [class]="globalStylingClass"
    [rightIcon]="rightIcon ?? ''"
    [leftIcon]="leftIcon ?? ''"
    [rightIconSize]="iconStyle"
    [leftIconSize]="iconStyle"
    [isAllowedGlobalStyling]="isAllowedGlobalStyling"
    [disabled]="disableButton"
    (click)="
      goToLink(
        multiIconQuickLinksData.url,
        multiIconQuickLinksData.role
      )
    "
    [style.height]="'100%'"
  ></finx-button>
</div>
